import { useState } from "react";
import type { VaultEntry } from "@akhshy/types";
import { FilterBar, type VaultFilter } from "../molecules/FilterBar.tsx";
import { VaultItem } from "../molecules/VaultItem.tsx";
import { Spinner } from "../atoms/Spinner.tsx";
import { LoadMore } from "../atoms/LoadMore.tsx";
import { usePaginated } from "../../lib/usePaginated.ts";
import { client } from "../../lib/api.ts";
import { FALLBACK_VAULT } from "../../lib/fallback.ts";

export function VaultGrid() {
  const [filter, setFilter] = useState<VaultFilter>("all");
  const kind = filter === "all" ? undefined : filter;

  const { items, loading, hasMore, total, loadMore } = usePaginated<VaultEntry>(
    (page) => client.vault.list({ page, pageSize: 9, kind }),
    [filter],
    FALLBACK_VAULT.filter((e) => !kind || e.kind === kind).slice(0, 9),
  );

  const initialLoading = loading && items.length === 0;
  return (
    <div className="vault-list-view">
      <FilterBar active={filter} onChange={setFilter} />
      {initialLoading ? (
        <Spinner label="pulling the drawer open" />
      ) : total === 0 ? (
        <p className="vault-empty">nothing filed under that label yet…</p>
      ) : (
        <>
          <div className="vault-grid">
            {items.map((entry) => (
              <VaultItem key={entry.id} entry={entry} />
            ))}
          </div>
          <LoadMore
            hasMore={hasMore}
            loading={loading}
            total={total}
            count={items.length}
            onClick={loadMore}
          />
        </>
      )}
    </div>
  );
}
